<h4>Calcolo automatico Scadenze</h4>
<div *ngIf="numPag == 1">
    <div class="row">
        <div class="col-sm-12" *ngIf="codiceTipoData == 'PUB'">
            &Egrave; possibile calcolare ed inserire automaticamente nello scadenzario i termini collegati all'esito "{{esitoIns.tipoEsito.label}} di {{fascicolo.grado.label}} grado" (data pubblicazione {{esitoIns.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}).
        </div>
        <div class="col-sm-12" *ngIf="codiceTipoData == 'NOT'">
            &Egrave; possibile calcolare ed inserire automaticamente nello scadenzario i termini collegati all'esito "{{esitoIns.tipoEsito.label}} di {{fascicolo.grado.label}} grado" (data notifica {{esitoIns.dataNotifica | dateformatter:'DD/MM/YYYY'}}) appena inserito.
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            Se si vuole procedere, selezionare le varianti di calcolo e cliccare su Calcola, altrimenti cliccare su Chiudi.
        </div>
    </div>
    <br>
    <div class="row">
        <div checkBoxRadio class="col-sm-6" [labelInput]="'Abbreviazione dei termini'"
            idInput="abbreviazTermini" [objectReference]="abbreviazTermini" (onReturn)="abbreviazTermini = $event">
        </div>
        <div checkBoxRadio class="col-sm-6" [labelInput]="'Sospensione feriale'"
             idInput="sospFeriale" [objectReference]="sospFeriale" (onReturn)="sospFeriale = $event">
        </div>
    </div>
    <br>
    <div class="row">
        <p class="col-sm-3 col-xs-6">
        </p>
        <p submitButton
            class="col-sm-3 col-xs-6 col-sm-offset-6"
            [labelButton]="'Calcola'" (click)="calcolaTermini()"></p>
    </div>
</div>
<div *ngIf="numPag == 2">

    <div class="row">
        <div class="col-sm-12" *ngIf="codiceTipoData == 'PUB'">
            Di seguito sono elencati i termini calcolati automaticamente rispetto all'Esito "{{esitoIns.tipoEsito.label}} di {{fascicolo.grado.label}} grado" (data pubblicazione {{esitoIns.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}).
        </div>
        <div class="col-sm-12" *ngIf="codiceTipoData == 'NOT'">
            Di seguito sono elencati i termini calcolati automaticamente rispetto all'Esito "{{esitoIns.tipoEsito.label}} di {{fascicolo.grado.label}} grado" (data notifica {{esitoIns.dataNotifica | dateformatter:'DD/MM/YYYY'}}).
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            Selezionare quali si desidera inserire nello scadenzario.
        </div>
    </div>
    <br>

    <!--<div *ngIf="isLoadingPag2" style="height: 150px">
        <div spinner-load [waiting]="true"></div>
    </div>-->

    <ng-container *ngIf="!isLoadingPag2 && listaScadenzeAuto.length > 0">
        <table class="table-striped table aggiunta_classificazione">
            <caption class="sr-only">Tabella lista scadenze</caption>
            <tbody>
            <tr>
                <th style="width: 50%; display: table-cell; vertical-align: middle;">Termine</th>
                <th style="width: 30%; display: table-cell; vertical-align: middle;">Data</th>
                <th style="width: 20%"><div singleCheckBoxModInput [labelNotChecked]="'Seleziona tutti'" [labelChecked]="'Deseleziona tutti'" (onReturn)="gestisciSelezionaTutti($event)"></div></th>
            </tr>
            <tr *ngFor="let scadenzaAuto of listaScadenzeAuto; let i = index">
                <td style="display: table-cell; vertical-align: middle;">{{scadenzaAuto.nomeTermine}}</td>
                <td style="display: table-cell; vertical-align: middle;">{{ scadenzaAuto.dataTermine | dateformatter:'DD/MM/YYYY'}} <span *ngIf="abbreviazTermini && scadenzaAuto.flagAbbreviazioneTermini == 1">*</span></td>
                <td>
                    <div singleCheckBoxModInput [objectReference]="listaScadenzeAuto[i].selezionato" (onReturn)="listaScadenzeAuto[i].selezionato = $event"></div>
                </td>
            </tr>
            </tbody>
        </table>
        <div *ngIf="abbreviazTermini" class="row">
            <div class="col-sm-12">
                * Applicata abbreviazione dei termini
            </div>
        </div>
        <div *ngIf="sospFeriale" class="row">
            <div class="col-sm-12">
                ** Applicata a tutti i termini la sospensione feriale
            </div>
        </div>
        <br>
    </ng-container>
    <ng-container *ngIf="!isLoadingPag2 && listaScadenzeAuto.length == 0">
        <div class="row">
            <div class="col-sm-12" style="text-align: center">
                Nessun risultato
            </div>
        </div>
    </ng-container>

    <div class="row">
        <p class="col-sm-3 col-xs-3">
            <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="isLoadingInsScad" (click)="indietro()">Indietro</button>
        </p>
        <div class="col-sm-3 col-xs-6 col-sm-offset-6">
            <button type='Submit' class='btn btn-primary btn-block' [disabled]='listaScadenzeAuto.length == 0 || isLoadingInsScad' (click)="inserisciTermini()">
                Inserisci
                <span spinner [disable]="!isLoadingInsScad"></span>
            </button>
        </div>
    </div>
</div>
